import {removeProtocol} from "@/mixins/Helpers";

export const MEET_DOMAIN = removeProtocol(import.meta.env.VITE_APP_MEET_BASE_URL)
export const MEET_BASE_API_URL = import.meta.env.VITE_APP_MEET_BASE_URL + import.meta.env.VITE_APP_MEET_API_ENDPOINT;